import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';

import { HeadsetIcon } from '@/assets/icons/HeadsetIcon';
import imageboursePng from '@/assets/images/imagebourse.png';
import imagebourseWebp from '@/assets/images/imagebourse.webp';
import FamilleContrat from '@/components/FamilleContrat/FamilleContrat';

const ImageCard = {
  IMAGE_CARD_BOURSE_DEFAULT: imageboursePng,
  IMAGE_CARD_BOURSE_WEBP: imagebourseWebp,
};

const CardContactDescription = {
  DESCRIPTION_MIDDLE_CHAT: 'Un conseiller répond à toutes vos interrogations en temps réel',
  DESCRIPTION_MIDDLE_CONSEILLER: 'Un conseiller vous recontacte au créneau qui vous convient',
  DESCRIPTION_MIDDLE_APPEL: 'Du lundi au vendredi de 9h à 19h, jusqu’à 17h le samedi (service et appel gratuits)',
  DESCRIPTION_MIDDLE_CHAT_INDISPONIBLE: 'Un conseiller répond à toutes vos interrogations en temps réel',
};

const CardContactTitreIcon = {
  TITRE_CHAT: 'Chat',
  TITRE_ETRE_APPELER: 'Rappel par un conseiller',
  TITRE_APPELER_CONSEILLER: 'Appel à un conseiller',
};

const BackgroundChatIndisponibleTitre = {
  TEXT_CHAT_INDISPONIBLE: 'color-text-chat-insdisponible',
  TEXT_CHAT_DISPONIBLE: 'titleSectionColor',
};

const Icon = {
  ICON_CHAT: <MtxIcon name="chat" size={40} />,
  ICON_RAPPEL_CONSEILLER: <HeadsetIcon height={40} width={40} color="var(--totem-text-color-secondary)" />,
  ICON_RAPELLER_CONSEILLER: <MtxIcon name="phonecall-outcoming" size={40} />,
};

const IconButtonOperation = {
  ICON_EFFECTUER_VERSEMENT: <MtxIcon name="transaction" size={26} />,
  ICON_FLECHE: <MtxIcon name="arrow-right" size={26} />,
  ICON_INVESTIR: <MtxIcon name="euro" size={26} />,
  ICON_ARBITRAGE: <MtxIcon name="balance" size={26} />,
  ICON_RACHAT_RETRAIT: <MtxIcon name="money-withdrawal" size={26} />,
};

const TitreButtonOperation = {
  TITRE_VERSEMENT: 'Faire un versement',
  TITRE_INVESTIR: 'Investir',
  TITRE_ARBITRAGE: 'Faire un arbitrage',
  TITRE_RACHAT_RETRAIT: 'Faire un rachat/retrait',
};

const SousTitreButtonOperation = {
  SOUS_TITRE_VERSEMENT: 'Reversez de l’argent rapidement',
  SOUS_TITRE_INVESTIR: 'Démarrez un projet de placement',
  SOUS_TITRE_ARBITRAGE: 'Redistribuez votre capital',
  SOUS_TITRE_RACHAT_RETRAIT: 'Récupérez votre épargne',
};

const TITRE_FAMILLE = {
  ASSURANCEVIE: 'Assurance-vie',
  LIVRET: 'Livret',
  RETRAITE: 'Retraite',
  DEFISCALISATION: 'Défiscalisation',
  IMMOBILIER: 'Immobilier',
  BOURSE: 'Bourse',
};

const FamilleCardReprendreSouscription = {
  ASSURANCEVIE: <FamilleContrat titreFamilleContrat="ASSURANCEVIE" />,
  LIVRET: <FamilleContrat titreFamilleContrat="LIVRET" />,
  RETRAITE: <FamilleContrat titreFamilleContrat="RETRAITE" />,
  DEFISCALISATION: <FamilleContrat titreFamilleContrat="DEFISCALISATION" />,
  IMMOBILIER: <FamilleContrat titreFamilleContrat="IMMOBILIER" />,
  BOURSE: <FamilleContrat titreFamilleContrat="BOURSE" />,
};

export {
  ImageCard,
  CardContactDescription,
  CardContactTitreIcon,
  BackgroundChatIndisponibleTitre,
  Icon,
  IconButtonOperation,
  TitreButtonOperation,
  SousTitreButtonOperation,
  TITRE_FAMILLE,
  FamilleCardReprendreSouscription,
};
